import Header from '../components/Header';
import CustomText from '../elements/CustomText';
import { SimpleCopyField } from '../elements/SimpleStoreCopyField';
import { RefContextLanguage } from '../providers/LanguageProvider';
import * as libCon from '../community-hats-js-library/Constants';
import * as locCon from '../LocalConstants';
import { WearableSerialExtractor } from '../components/WearableSerialExtractor';
import { useState } from 'react';
import { ExportOutlined } from '@ant-design/icons';
import links from './../data/links.json';
import { goToThirdPartyLink, isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions';
import { getATOField, RefStoredBooleanValue, setATOField, setMultipleValues, setStoredValue, StateStoredValue } from '../hooks/StoreHooks';
import CustomButton from '../elements/CustomButton';
import { BackButtonLarge } from '../elements/BackButton';
import { SyncATOButton } from '../elements/SyncATOButton';
import CheckboxGroup from '../elements/CheckboxGroup';
import CompletionStatusText from '../elements/CompletionStatusText';


export function ToolWearableSerialChecker() {

  const i18n = RefContextLanguage()


  const [initialSerial, setInitialSerial] = useState(() => getATOField(locCon.AT_OBJECT_WEARABLE, libCon.ATF_SERIAL))
  const [serial, setSerial] = useState(null)


  const [serialsMatch, setSerialsMatch] = StateStoredValue(locCon.WSC_SERIALS_MATCH)


  const allCheckboxes = [
    locCon.WSC_UPDATE_SERIAL,
    locCon.WSC_UPDATE_WEARABLE,
    locCon.WSC_UPDATE_BUNDLE,
    locCon.WSC_UPDATE_PLACEMENT
  ]

  const serialOverwriten = RefStoredBooleanValue(locCon.WSC_UPDATE_SERIAL)


  const restartProcess = () => {
    setStoredValue(locCon.FITBIT_URL, null)
    setInitialSerial(getATOField(locCon.AT_OBJECT_WEARABLE, libCon.ATF_SERIAL))
    setSerialsMatch(null)

    // Usablity
    let checkBoxValues = {}

    allCheckboxes.forEach(k => checkBoxValues[k] = false)

    setMultipleValues(checkBoxValues)

    setSerial(null)

  }

  const overrideSerial = () => {
    setATOField(locCon.AT_OBJECT_WEARABLE, libCon.ATF_SERIAL, serial)
    setStoredValue(locCon.WSC_UPDATE_SERIAL, true)
  }



  return (
    <div className="mainAppContainer">
      <div className='pageContainer'>
        <Header long={true} />
        <CustomText type={locCon.MODULE_TITLE_TEXT}>{i18n.t("wearableSerialChecker")}</CustomText>
        <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => restartProcess()}>{i18n.t("restartProcess")}</CustomButton>

        <SimpleCopyField value={initialSerial} title={i18n.t("currentWearableSerial")} />
        <div className={"horizontalLine"} />

        <div className='verticalSection' style={{ marginBottom: "3vh" }}>
          <CustomText type={locCon.ELEMENT_TITLE_TEXT}>{i18n.t("getWearableSerialNumber")}</CustomText>

          <div className='horizontalSectionCenter'>
            <CustomText type={locCon.ELEMENT_TEXT}>{i18n.t("wearableSerial")}</CustomText>
            <ExportOutlined style={{ marginLeft: 15, color: "var(--primary-color-5)", fontSize: 30 }} onClick={() => { goToThirdPartyLink(links[locCon.AWP_GET_WEARABLE_SERIAL][libCon.LINK]) }} />
          </div>
        </div>
        <WearableSerialExtractor serial={serial} setSerial={(s) => { setSerial(s); setSerialsMatch(s === initialSerial) }} urlStorageId={locCon.FITBIT_URL} enableCopy={true} setSerialToNullWhenLinkIsNull={true} />

        <div className={"horizontalLine"} />
        {
          isNullOrUndefined(serial)
            ? <CustomText type={locCon.INSTRUCTIONS_TEXT}>{i18n.t("pleaseExtractTheNewSerial")}</CustomText>
            : serialsMatch === true
              ? <div className='verticalSection'>
                <CustomText type={locCon.SUCCESS_TEXT}>{i18n.t("serialMatch")}</CustomText>
                <BackButtonLarge />
              </div>
              : <div className='verticalSection'>
                <CustomText type={locCon.DANGER_TEXT}>{i18n.t("serialsDontMatch")}</CustomText>

                {/* Update serial */}
                <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t("updateSerial")}</CustomText>
                <CustomText type={locCon.INSTRUCTIONS_TEXT}>{i18n.t("updateSerialText")}</CustomText>
                <CheckboxGroup disableClick={true} mainCheckbox={{
                  [libCon.ID]: locCon.WSC_UPDATE_SERIAL,
                  [libCon.TEXT]: i18n.t("updateSerial"),
                  [libCon.CONTAINER]: <div className='verticalSection'>
                    {!serialOverwriten
                      ? <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => overrideSerial()}>{i18n.t("updateSerial")}</CustomButton>
                      : <CustomText type={locCon.SUCCESS_TEXT}>{i18n.t("serialUpdated")}</CustomText>
                    }</div>
                }} />

                <div className="horizontalLine" />


                {/* Wearable*/}
                <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t("syncWearable")}</CustomText>
                <CustomText type={locCon.INSTRUCTIONS_TEXT}>{i18n.t("syncWearableText")}</CustomText>
                <CheckboxGroup disableClick={true} mainCheckbox={{
                  [libCon.ID]: locCon.WSC_UPDATE_WEARABLE,
                  [libCon.TEXT]: i18n.t("syncWearable"),
                  [libCon.CONTAINER]: <SyncATOButton atoId={locCon.AT_OBJECT_WEARABLE} atoBehavior={libCon.ATO_BEHAVIOR_PULL} onClickCleanup={(val) => setStoredValue(locCon.WSC_UPDATE_WEARABLE, val)} />
                }} />

                <div className="horizontalLine" />


                {/* Add / Sync Bundle to database*/}
                <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t("updateBundle")}</CustomText>
                <CustomText type={locCon.INSTRUCTIONS_TEXT}>{i18n.t("updateBundleText")}</CustomText>
                <CheckboxGroup disableClick={true} mainCheckbox={{
                  [libCon.ID]: locCon.WSC_UPDATE_BUNDLE,
                  [libCon.TEXT]: i18n.t("updateBundle"),
                  [libCon.CONTAINER]: <SyncATOButton atoId={locCon.AT_OBJECT_BUNDLE} atoBehavior={libCon.ATO_BEHAVIOR_UPDATE_CREATE} onClickCleanup={(val) => setStoredValue(locCon.WSC_UPDATE_BUNDLE, val)} />
                }} />

                <div className="horizontalLine" />

                {/* Wearable Placement*/}
                <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t("syncWearablePleacement")}</CustomText>
                <CustomText type={locCon.INSTRUCTIONS_TEXT}>{i18n.t("syncWearablePlacementText")}</CustomText>
                <CheckboxGroup disableClick={true} mainCheckbox={{
                  [libCon.ID]: locCon.WSC_UPDATE_PLACEMENT,
                  [libCon.TEXT]: i18n.t("syncWearablePleacement"),
                  [libCon.CONTAINER]: <SyncATOButton atoId={locCon.AT_OBJECT_WEARABLE_PLACEMENT} atoBehavior={libCon.ATO_BEHAVIOR_UPDATE} onClickCleanup={(val) => setStoredValue(locCon.WSC_UPDATE_PLACEMENT, val)} />
                }} />

                <div className="horizontalLine" />


                <CompletionStatusText checkBoxIds={allCheckboxes} />

              </div>


        }

      </div>
    </div>
  );
}

export default ToolWearableSerialChecker


